// extracted by mini-css-extract-plugin
module.exports = {"button":"styles__button___2oNPe","disabled":"styles__disabled___I1Lr-","purple":"styles__purple___2u-0h","white":"styles__white___3jQwS","red":"styles__red___tvUC-"};